// extracted by mini-css-extract-plugin
export default {"section":"styles__section___DuChl layout__section___dlUur","packageInput":"styles__packageInput___VUBt4 styles__packageInput___erKel"};